import React from "react";

// eslint-disable-next-line no-restricted-imports
import { Select as SelectDS, SelectProps } from "@packages/ds";
import { OnChangeValue, ActionMeta } from "react-select";

import { sendPendoEventSelect } from "Store/analytics/pendoFunctions";

/**
 * Select component with analytics tracking
 */
const Select = <Option, IsMulti extends boolean = false>({
  onChange,
  ...props
}: SelectProps<Option, IsMulti>) => (
  <SelectDS
    {...props}
    onChange={(
      newValue: OnChangeValue<Option, IsMulti>,
      actionMeta: ActionMeta<Option>
    ) => {
      onChange && onChange(newValue, actionMeta);
      const analyticId = props.id || props.name;

      // Handle different types of values (single or multi-select)
      let selectedValue;
      if (newValue) {
        // For multi-select
        if (Array.isArray(newValue)) {
          selectedValue = newValue.map(item =>
            // Safely access value property if it exists
            typeof item === "object" && item !== null && "value" in item
              ? item.value
              : item
          );
        }
        // For single select
        else if (
          typeof newValue === "object" &&
          newValue !== null &&
          "value" in newValue
        ) {
          selectedValue = newValue.value;
        } else {
          selectedValue = newValue;
        }
      }

      sendPendoEventSelect(analyticId, selectedValue);
    }}
  />
);

export default Select;
